import {
  UserFragment,
  TagFragment,
  DistributionGroupFragment,
} from "gql/graphql";
import { MENTION_TYPE } from "modules/utils/Constants";

type MentionResolver = (
  id: string,
  type: MENTION_TYPE,
) => UserFragment | TagFragment | DistributionGroupFragment | null;

let resolver: MentionResolver | null = null;

export const setMentionResolver = (fn: MentionResolver) => {
  resolver = fn;
};

export const resolveMention = (
  id: string,
  type: MENTION_TYPE,
): UserFragment | TagFragment | DistributionGroupFragment | null =>
  resolver?.(id, type) ?? null;
